// PHASE 7: What content format engages you most?
import MultipleChoiceQuestionPage from '@app-studio-web/ui/pages/MultipleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '🎬',
    title: 'pages.onboarding.contentFormat.answer1',
  },
  {
    emoji: '🎙️',
    title: 'pages.onboarding.contentFormat.answer2',
  },
  {
    emoji: '📖',
    title: 'pages.onboarding.contentFormat.answer3',
  },
  {
    emoji: '🎮',
    title: 'pages.onboarding.contentFormat.answer4',
  },
  {
    emoji: '💬',
    title: 'pages.onboarding.contentFormat.answer5',
  },
  {
    emoji: '🎵',
    title: 'pages.onboarding.contentFormat.answer6',
  },
  {
    emoji: '📝',
    title: 'pages.onboarding.contentFormat.answer7',
  },
]

export default function ContentFormatPage() {
  return (
    <MultipleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.contentFormat.title"
      subtitle="pages.onboarding.contentFormat.subtitle"
    />
  )
}
